
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/book-a-visit",
      function () {
        return require("private-next-pages/book-a-visit.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/book-a-visit"])
      });
    }
  